import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n';
import '@/css/new.scss'
import '@/css/modelmin.scss'
import './plugins/element.js'
import './plugins/axios'
import axios from 'axios'
import ElementUI from 'element-ui'
import QS from 'qs'
import store from './store'
import Messwarn from '@/components/messwarn'
import ElementLocale from 'element-ui/lib/locale'
import VideoPlayer from 'vue-video-player'
import {calculation} from '@/assets/calculation.js'
import vueEsign from 'vue-esign'

// import 
Vue.use(vueEsign)
Vue.use(VideoPlayer)
Vue.use(Messwarn)
Vue.use(ElementUI)
Vue.prototype.$calculation = calculation
Vue.prototype.$ajax = axios
Vue.prototype.qs = QS

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

ElementLocale.i18n((key, value) => i18n.t(key, value))

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    mounted() {
        window.addEventListener('unload', this.saveState)
        window.addEventListener("load", () => {
            sessionStorage.clear();
        });
    },
    methods: {
        saveState() {
            sessionStorage.setItem('state', JSON.stringify(this.$store.state));
        }
    }
}).$mount('#app')